<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Payment Order Records
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row class="py-2 justify-items-between">
                  <!-- Search -->
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <!-- Export Buttons -->
                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn prepend-icon="mdi mdi-download" color="success" variant="flat" @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" color="primary" variant="flat" @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" color="red" variant="flat" @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <!-- Add New -->
                  <v-col md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/payroll/bonus-payment-order/create')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Payment Order
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <!-- Table -->
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <!-- Index -->
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>

                  <!-- Approval Status -->
                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Waiting for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip v-else color="green" size="small">
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <!-- Payment Status -->
                  <template v-slot:item.payment_status="{ item }">
                    <v-chip
                      :color="item.payment_status === 'confirmed' ? 'success' : 'grey'"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ item.payment_status }}
                    </v-chip>
                  </template>

                  <!-- Actions -->
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="brown"
                      @click="viewPaymentOrderInvoice(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    itemsPerPage: -1,
    panel: [0],
    search: "",
    loading: false,
    headers: [
      { title: "#SL", key: "index", align: "center", sortable: false, width: "50px" },
      { title: "Payment Date", key: "payment_date", align: "left" },
      { title: "Payment Method", key: "payment_method", align: "left" },
      { title: "Payment Account Head", key: "payment_account_head.name", align: "left" },
      { title: "Total Order Amount", key: "total_order_amount", align: "left" },
      { title: "Approval Status", key: "approval_status_display", align: "left" },
      { title: "Payment Status", key: "payment_status", align: "left" },
      { title: "Actions", key: "actions", sortable: false },
    ],
  }),

  created() {
    if (this.$store.getters.getBonusPaymentList.length === 0) {
      this.loading = true;
      this.$store.dispatch("getBonusPaymentList").finally(() => {
        this.loading = false;
      });
    }
  },

  computed: {
    getSchema() {
      return this.$store.getters.getBonusPaymentList;
    },
  },

  methods: {
    goTo(path) {
      this.$router.push({ path }).catch(() => {});
    },

    viewPaymentOrderInvoice(item) {
      this.$router.push({ name: "bonus-payment-order-invoice", query: { id: item.id } });
    },

    exportToPDF() {},
    exportToExcel() {},
    exportToCSV() {},
  },
};
</script>
